import Dexie from 'dexie';
import { Exercise } from '@/models/exercise.model';
import Vue, { PluginObject, ComponentOptions, VueConstructor } from 'vue';
import { ExerciseActivity } from '@/models/exercise-activity.model';

// Type augment
declare module 'vue/types/vue' {
  interface Vue {
    $database: GymCatDB;
  }
}

// ComponentOptions is declared in types/options.d.ts
declare module 'vue/types/options' {
  interface ComponentOptions<V extends Vue> {
    database?: GymCatDB;
  }
}

let vue: VueConstructor<Vue>;

const GymCatDbPlugin: PluginObject<ComponentOptions<Vue>> = {
  install: function(_Vue) {
    if (vue === _Vue) {
      // console.error('already installed?');
      return;
    }
    vue = _Vue;

    vue.mixin({
      beforeCreate() {
        const options = this.$options;
        const db = options?.database || options?.parent?.$database;
        if (db) {
          this.$database = db;
        }
      },
    });
  },
};

Vue.use(GymCatDbPlugin);

export class GymCatDB extends Dexie {
  // Declare implicit table properties.
  // (just to inform Typescript. Instanciated by Dexie in stores() method)
  exercises: Dexie.Table<Exercise, string>; // number = type of the primkey
  exerciseActivities: Dexie.Table<ExerciseActivity, string>;
  //...other tables goes here...

  constructor() {
    super('GymCatDB');
    this.version(1).stores({
      exercises: '&id, name, created, modified, metric', // NOTE: try create a "build db def (DEXIE only) with annotations"
      exerciseActivities: '&id, exerciseId, created, modified',
      // setActivities: '',
      //...other tables goes here...
    });

    // this.version(2)
    //   .stores({
    //     exercises: 'id, name, created, modified',
    //   })
    //   .upgrade(tx => {
    //     // Will only be executed if a version below 2 was installed.
    //     return tx
    //       .table('exercises')
    //       .toCollection()
    //       .modify(exercise => {
    //         exercise.created = new Date();
    //       });
    //   });
    // The following line is needed if your typescript
    // is compiled using babel instead of tsc:
    this.exercises = this.table('exercises');
    this.exerciseActivities = this.table('exerciseActivities');
  }
}

const db = new GymCatDB();

export default db;
